interface FlattenObjectResult {
  [key: string]: any;
}

export const flattenObject = (obj: any, parentKey = ''): FlattenObjectResult => {
  let result: FlattenObjectResult = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        result = { ...result, ...flattenObject(obj[key], newKey) };
      } else {
        result[newKey] = obj[key];
      }
    }
  }

  return result;
}